import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1.5),
    },
  },
  results: {
    marginTop: theme.spacing(3),
  },
  linhaTabela: {
    fontSize: '12px',
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(4),
  },
  tableContainer: {
    paddingBottom: theme.spacing(2),
  },
  fieldGroup: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  dados: {
    padding: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      padding: 0,
    },
  },
  cicatrizCard: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1.5),
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderLeft: `4px solid ${theme.palette.primary.main}`,
    borderRadius: '12px',
    boxShadow: 'none',
    transition: 'box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
      borderColor: theme.palette.primary.main,
    },
  },
}))

export default useStyles
